import React from 'react';
import { ChevronDown } from 'lucide-react';
import { faqData } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section className="py-20 bg-white" id="faq">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0E3A5F] mb-4">
              {faqData.title}
            </h2>
            <p className="text-xl text-gray-600">
              Common questions about switching from SaaS to custom software
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl shadow-lg border-2 border-gray-100">
            <Accordion type="single" collapsible className="w-full">
              {faqData.questions.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border-b border-gray-200 last:border-0">
                  <AccordionTrigger className="text-left py-5 hover:text-[#1F6FB2] transition-colors">
                    <span className="font-semibold text-lg text-[#0E3A5F]">
                      {faq.question}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-700 leading-relaxed pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          {/* Still Have Questions CTA */}
          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-4">
              Still have questions?
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 text-[#1F6FB2] hover:text-[#7AC943] font-semibold transition-colors duration-200"
            >
              Schedule a free consultation to get answers
              <ChevronDown className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
